// extracted by mini-css-extract-plugin
module.exports = {"root":"AppChangeWarning_root__u9y4u","buttonWrapper":"AppChangeWarning_buttonWrapper__q__gi"};